import { z, isoZ } from 'my-zod'

export const subscriptionAttributes = z.object({
  activationDate: isoZ.instant(),
  billingCycleAnchor: z.ostring(),
  currentPeriodEnd: z.ostring(),
  currentPeriodStart: z.ostring(),
  nextCreditLoadDate: z.string().nonempty(),
  startDate: isoZ.instant(),
  status: z.string().nonempty(),
  planProductId: z.string().nonempty(),
  priceId: z.string().nonempty(),
  canceledAt: isoZ.instant().nullish()
})

export type subscriptionAttributes = z.infer<typeof subscriptionAttributes>
